import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-redo.png'

const RedoBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default RedoBtn
